<div class="cet-dropdown">
  <div class="cet-dropdown-btn">
    <input
      id="cet-input-{{ rand }}"
      class="cet-bg-white {{ currentValue?.className }}"
      (blur)="close()"
      (click)="toggle()"
      [value]="currentValue?.[text] || (data && data.length ? 'Select' :'loading...')"
      readonly
    />
    <img
      src="assets/images/down.webp"
      alt="toggle dropdown"
      style="width: 20px; margin-inline: 0.5rem"
    />
  </div>
  <ul
    class="cet-dropdown-menu cet-custom-scroll"
    id="cet-ddM-{{ rand }}"
    *ngIf="data?.length"
  >
    <li
      (click)="Select(item)"
      class="{{ item?.className }}"
      *ngFor="let item of data"
    >
      {{ item[text] }}
    </li>
  </ul>
</div>
